import { LocalizationText } from "@/app/index";
import { useModalLicenseAgreementStyles } from "./modal-license-agreement.styles";
import { useContextModalLicenseAgreement } from "../context/index";
import { ModalFooterActions } from "@/components/modal-footer-actions/index";

export const ModalLicenseAgreementFooter = () => {
  const { styles } = useModalLicenseAgreementStyles();
  const { sendingEmail, accept, handleSendEmail } =
    useContextModalLicenseAgreement();

  return (
    <ModalFooterActions
      onSecondary={() => handleSendEmail()}
      onPrimary={() => accept()}
      secondaryText={
        <LocalizationText value="modal.license.agreement.button.email.text" />
      }
      primaryText={
        <LocalizationText value="modal.license.agreement.button.accept.text" />
      }
      className={styles.actions}
      primaryButtonProps={{ size: "large" }}
      secondaryButtonProps={{ size: "large", loading: sendingEmail }}
    />
  );
};
